import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import RtkBaseQueryWithReauth from './RtkBaseQueryWithReauth';
import ApiPath from "./ConstantApi";
import { TermsConditionResponse, PrivacyAndPolicyResponse, BannerResponse, BannerModel, BannerResDataModel, DynamicFooterLinks, DynamicFooterResponse} from './../Helpers/Interfaces/SettingType';




export const SettingsService = createApi({
  reducerPath: "SettingsService",
  baseQuery: RtkBaseQueryWithReauth(process.env.REACT_APP_BASE_URL || ''),
  tagTypes: ["Settings", "Term", "PrivacyPolicy", "Banner", "DynamicFooterLinks"],
  endpoints: (builder) => ({
    getTermsData: builder.query<any, any>({
      query: () => ({
        url: `${ApiPath.getTerms}`,
        method: "GET",
      }),
      transformResponse: (response: { data: TermsConditionResponse }) => response.data,
      providesTags: ["Term"],
    }),

    updateTerms: builder.mutation({
      query: (data) => ({
        url: `${ApiPath.updateTerms}/${data?.id}`,
        method: 'PUT',
        body: data.formData,
      }),
      invalidatesTags: ["Term"],
    }),

    getPrivacyPolicy: builder.query<any, any>({
      query: () => ({
        url: `${ApiPath.getPrivacyPolicy}`,
        method: "GET",
      }),
      transformResponse: (response: { data: PrivacyAndPolicyResponse }) => response.data,
      providesTags: ["PrivacyPolicy"],
    }),
    updatePrivacyPolicy: builder.mutation({
      query: (data) => ({
        url: `${ApiPath.updatePrivacyPolicy}/${data?.id}`, // Assuming the same endpoint for update
        method: 'PUT',
        body: data.formData,
      }),
      invalidatesTags: ["PrivacyPolicy"],
    }),

    getBannerList: builder.query<BannerResponse, { page: number; pageSize: number }>({
      query: ({ page, pageSize }) => ({
        url: `${ApiPath.getBanners}`,
        method: 'GET',
        params: { page, pageSize, getall: true },
      }),
      providesTags: ["Banner"],
    }),

    addBanner: builder.mutation<void, BannerModel>({
      query: (newBanner) => ({
        url: `${ApiPath.addBanner}`,
        method: 'POST',
        body: newBanner,
      }),
      invalidatesTags: ["Banner"],
    }),

    updateBanner: builder.mutation<void, { id: string; banner: BannerResDataModel }>({
      query: ({ id, banner }) => ({
        url: `${ApiPath.updateBanner}/${id}`,
        method: 'PUT',
        body: banner,
      }),
      invalidatesTags: ["Banner"],
    }),

    deleteBanner: builder.mutation<void, string>({
      query: (id) => ({
        url: `${ApiPath.deleteBanner}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ["Banner"],
    }),

      addDynamicFooterLinks: builder.mutation<void, DynamicFooterLinks>({
      query: (reqBody) => ({
        url: `${ApiPath.addDynamicFooterLinks}`,
        method: 'POST',
        body: reqBody,
      }),
      invalidatesTags: ["DynamicFooterLinks"],
    }),

      getDynamicFooterLinks: builder.query<DynamicFooterResponse, void>({
      query: () => ({
        url: `${ApiPath.addDynamicFooterLinks}`,
        method: 'GET',
      }),
      providesTags: ["DynamicFooterLinks"],
    }),

  }),
});

export const { useGetTermsDataQuery, useUpdateTermsMutation, useGetPrivacyPolicyQuery, useUpdatePrivacyPolicyMutation, useGetBannerListQuery, useAddBannerMutation, useUpdateBannerMutation, useDeleteBannerMutation, useAddDynamicFooterLinksMutation, useGetDynamicFooterLinksQuery } = SettingsService;